/**
 * @generated SignedSource<<e3a749fd059199712a6ec74946e82c9e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TeamDefaultTodoCategoryTodoDeleteSubscription$variables = {
  categoryId: string;
  teamId: string;
};
export type TeamDefaultTodoCategoryTodoDeleteSubscription$data = {
  readonly todoDeleted: {
    readonly category: {
      readonly team: {
        readonly id: string;
        readonly notResolvedCount: number;
      };
    } | null;
    readonly id: string;
  } | null;
};
export type TeamDefaultTodoCategoryTodoDeleteSubscription = {
  response: TeamDefaultTodoCategoryTodoDeleteSubscription$data;
  variables: TeamDefaultTodoCategoryTodoDeleteSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "categoryId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamId"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "categoryIds.0",
        "variableName": "categoryId"
      }
    ],
    "kind": "ListValue",
    "name": "categoryIds"
  },
  {
    "items": [
      {
        "kind": "Variable",
        "name": "teamIds.0",
        "variableName": "teamId"
      }
    ],
    "kind": "ListValue",
    "name": "teamIds"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "teamId"
    }
  ],
  "concreteType": "TodoCategoryTeam",
  "kind": "LinkedField",
  "name": "team",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notResolvedCount",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamDefaultTodoCategoryTodoDeleteSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Todo",
        "kind": "LinkedField",
        "name": "todoDeleted",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoCategory",
            "kind": "LinkedField",
            "name": "category",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TeamDefaultTodoCategoryTodoDeleteSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Todo",
        "kind": "LinkedField",
        "name": "todoDeleted",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoCategory",
            "kind": "LinkedField",
            "name": "category",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3fe268a5c8c47adb8cb00c3fe62d994a",
    "id": null,
    "metadata": {},
    "name": "TeamDefaultTodoCategoryTodoDeleteSubscription",
    "operationKind": "subscription",
    "text": "subscription TeamDefaultTodoCategoryTodoDeleteSubscription(\n  $categoryId: ID!\n  $teamId: ID!\n) {\n  todoDeleted(categoryIds: [$categoryId], teamIds: [$teamId]) {\n    id\n    category {\n      team(id: $teamId) {\n        id\n        notResolvedCount\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "18871cb63a27b50305b4afd86aa12b9b";

export default node;
